<template>
	<div class="complaint2">
        <main>
            <div class="list">
                <van-dialog v-model="show_title" title="本平台温馨提示" style="color:black">
                    <div style="padding: 0 20px;">
                        <p>1、如您发现华统股份全体员工、管理干部存在贪污腐败、吃拿卡要、弄虚作假、徇私舞弊、利益输送等违纪违法行为，请向我们举报。一经查实，给予举报人500-1,000,000.00元现金奖励！！！</p>
                        <p>2、不管您是否实名举报，您反映的内容公司严格保密，请您不要有后顾之忧，为快速核实您反映的情况，请您尽量提供充分的线索和依据。</p>
                        <p>3、同案举报同案给予免责。</p>
                        <p>4、我们将对您所反映的问题或意见、建议及时跟进处理，并尽我们最大的努力作出回复（举报反馈期限：3-7个工作日，复杂案件30日以内）,若您已留下联系电话，请保持电话畅通，也可关注举报平台-进度查询实时了解受理进度。</p>
                    </div>
                </van-dialog>
                <van-tabs v-model="active" @click="onClick">
                    <van-tab title="举报">
                        <br>
                        <br>
                        <van-field v-model="name" label="姓名（选填）"  /> 
                        <!-- //正则 -->
                        <van-field v-model="tell" label="电话（选填）"  />
                        <p style="padding:0 20px">注：举报电话请保持畅通，举报属实会第一时间跟您沟通奖金发放，您的信息我们将严格保密   </p>

                        <van-field v-model="dx_org" label="举报对象公司"/>
                        <van-field v-model="dx_name" label="举报对象姓名"/>

                        <van-field
                            v-model="message1"
                            autosize
                            label="涉及问题"
                            type="textarea"
                            maxlength="3000"
                            placeholder="索贿受贿/公款消费/截留公司收入/私自处理资产/盗取、盗卖资产/虚报费用/私设小金库/采购价虚高，高于市场正常价/私刻印章/泄露机密/利用职权谋取不正当利益/其他"
                            show-word-limit
                        />

                        <p style="padding:0 20px">温馨提示：请您举报描述时尽可能据实告知以下内容：被举报人的姓名、工作岗位、违法违纪事实的具体情节和证据(时间、地点、人物、事情经过及物证、书证，合同、照片、截图等)，录音/视频等原始材料若有需要，可后续补充，举报请客观公正、实事求是。   </p>


                        <van-field
                            v-model="message2"
                            autosize
                            label="举报内容"
                            type="textarea"
                            maxlength="3000"
                            placeholder="内容尽可能清晰的描述事件过程，并且包换时间、地点等信息，如：2025年4月24日22:18，我在XX公司发货平台看到发货员XXX收经销商红包"
                            show-word-limit
                        />

                        <h4>图片上传（不超过8张）</h4>
                        <van-uploader  v-model="fileList" multiple :max-count="8"  :before-read="beforeRead"/>
                        <br><br>
                        <van-button type="info" style="width:100%" @click="sub()">提交</van-button>
                    </van-tab>

                    <van-tab title="进度查询">
                        <br>
                        <br>
                        <van-field v-model="code" label="查询码" placeholder="查询码" input-align="right"/>
                      
                        <br>
                        <van-button type="danger" size="small" style="width: 100%;margin-bottom: 20px;" @click="search">搜索</van-button>

                        <el-card v-for="(item,index) in list" style="margin-bottom: 20px;">
                            <van-cell :value="item.name" title="姓名" />
                            <van-cell :value="item.tell" title="电话" />
                            <van-cell :value="item.dx_org" title="举报对象公司" />
                            <van-cell :value="item.dx_name" title="举报对象姓名" />
                            <van-cell :value="item.message1" title="涉及问题" />
                            <van-cell :value="item.message2" title="举报内容" />

                            <van-cell v-if="item.status==0" title="进度" value="待受理" />
                            <van-cell v-if="item.status==1" title="进度" value="已受理" />
                            <van-cell v-if="item.status==2" title="进度" value="已完结" />
                            <van-cell v-if="item.status==3" title="进度" value="已拒绝" />
                            <van-cell :value="item.time" title="反馈时间" />

                            <van-cell title="意见" :value="item.fankui" />
                            
                        </el-card>

                    </van-tab>
                </van-tabs>

             
            </div>

        </main>
    </div>
</template>

<script>   
    import { url } from '../router/api';
	export default{
		data(){
			return{
                show_title:true,

                active:'',
                name:'',
                tell:'',
                code:'',

                dx_org:'',
                dx_name:'',
                message1:'',
                message2:'',

                fileList: [],
                loading:'',

             
                list:[]
            }
        },

        created() {
            var id = this.$route.query.id?1:0
            this.active = id
        },

		methods: {
            onClick(id) {
                this.name = '',
                this.tell = '',
                this.dx_org = '',
                this.dx_name = '',
                this.message1 = '',
                this.message2 = '',
                this.list = []
            },

            beforeRead(file){
               return this.$compress(file)
            },

            sub() {
                if(this.active == 0) {
                    if(this.dx_org=='') {
                        this.$dialog.alert({
                            title: '提示',
                            message: '举报对象公司不能为空',
                        }).then(() => {
                            return;
                        });
                    } else if(this.dx_name=='') {
                        this.$dialog.alert({
                            title: '提示',
                            message: '举报对象姓名不能为空',
                        }).then(() => {
                            return;
                        });
                    } else if(this.message1=='') {
                        this.$dialog.alert({
                            title: '提示',
                            message: '涉及问题不能为空',
                        }).then(() => {
                            return;
                        });
                    } else if(this.message2=='') {
                        this.$dialog.alert({
                            title: '提示',
                            message: '举报内容不能为空',
                        }).then(() => {
                            return;
                        });
                    } else  {
                        this.$dialog.confirm({
                            title: '提示',
                            message: '是否确定提交',
                        }).then(() => {
                            this.photo()
                        }).catch(() => {});
                    }
                }
            },

            photo() {
                if(this.fileList!='') {
                    this.loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: '加载中',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var formData =new FormData();
                    this.fileList.map(item=>{
                        formData.append('file[]',item.file);
                    })
                    this.axios.post(url+'complaint/upload_complaint',(formData),{
                        headers: {  'Content-Type': 'multipart/form-data;' }
                    }).then(res=> {
                        if(res.data.code==1) {
                            this.loading.close();
                            this.sure2(res.data.data)
                        }  else {
                            this.loading.close();
                        }
                    }).catch(err=> {
                        this.loading.close();
                        console.log(err);
                    });
                } else {
                    this.sure2()
                }  
            },

            sure2(photo) {
                var currentTime = new Date();
                var year = currentTime.getFullYear();
                var month = currentTime.getMonth() + 1; // 注意月份从0开始，所以要加1
                var date = currentTime.getDate();
                var hours = currentTime.getHours();
                var minutes = currentTime.getMinutes();
                var seconds = currentTime.getSeconds();
                var time = year+month+date+hours+minutes+seconds;
                var number = Math.floor(Math.random()*100)
                var randomNumber = Math.floor(Math.random() * 26) + 65; 
                var randomLetter = String.fromCharCode(randomNumber);
                var randomNumber2 = Math.floor(Math.random() * 26) + 65; 
                var randomLetter2 = String.fromCharCode(randomNumber2);
                var code = randomLetter+randomLetter2+time+number
                this.axios.get(url+'complaint/subList', {
                    params:{
                        name:this.name,
                        tell:this.tell,

                        dx_org:this.dx_org,
                        dx_name:this.dx_name,

                        message1:this.message1,
                        message2:this.message2,
                        code:code,

                        url:photo?photo.toString():'',
                    }
                }).then(res=> {
                    if(res.data.code==1) {
                        this.$dialog.alert({
                            title: '重要提醒',
                            message: `<p>您好，您的举报信息已成功上报<br/>并已加密保护，您可在廉政审计官方举报平台--我的举报--进度查询，输入查询码${res.data.data.code}<b style=color:red>(请务必截图保存)</b>进行举报进度实时查询，请妥善保管以上查询码，切勿泄露。</p>`,
                            getContainer: ".complaint2",
                        }).then(() => {
                            this.active = 0
                            this.fileList = []
                            
                            this.name = '',
                            this.tell = '',

                            this.dx_org = '', 
                            this.dx_name = '',

                            this.message1 = '',
                            this.message2 = ''
                        });
                    }
                }).catch(err=> {
                    console.log(err);
                });
            },

            search() {
                if(this.code=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入查询码',
                    }).then(() => { });
                } else {
                    this.axios.get(url + 'complaint/searchComplaint', {
                        params:{
                            code:this.code,
                            time1:'',
                            time2:'',
                            page:'',
                            per_page:'',
                        }
                    }).then(res=> {
                        this.list = res.data.data.data
                        if(this.list.length==0) {
                            this.$dialog.alert({
                                title: '提示',
                                message: '暂无信息',
                            }).then(() => { });
                        }
                    }).catch(err=> {
                        console.log(err);
                    });
                }
            },
        }
    }
</script>

<style scoped="scoped" lang='less'>
    .complaint2 main {
        font-size: 14px;
        padding: 40px 16px 20px 16px;
        background-color: rgb(217,217,217);
        padding-bottom: 40px;
    }
    .complaint2 main .list {
        background-color: #fff;
        padding: 20px;
        color: #EE0A24;
    }
    .complaint2 /deep/ .van-dialog__header {
        color: #EE0A24;
    }
</style>